import { styled, Tab } from '@mui/material'

export const TabCustom:any  = styled(Tab)``

export const TabsRendererWrapper:any  = styled('div')`
  display: block;
  width: 100%;

  .MuiTabs-root {
    background-color: #f8f8f8;
  }
`
